import script from "./InMailCompositionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InMailCompositionModal.vue?vue&type=script&setup=true&lang=ts"

import "./InMailCompositionModal.vue?vue&type=style&index=0&id=23225a39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23225a39"]])

export default __exports__